﻿'use strict';
/*
    Subscriber service module.
    A service module to handle subscriber functions.
*/

var _ = require('lodash');


// @ngInject 
module.exports = function($location, $q, $http, $translate) {

    var svc = {};

    svc.subscriber = {
        npeId: $location.search()['npeid'],
        projectId: $location.search()['pid'],
        status: 'unknown',
        email: $translate.instant('CHECKING')
    }

    // if no npeid present on querystring then subscriber is invalid
    //console.log(svc.subscriber, 'svc.subscriber');
    if (svc.subscriber.npeId == null || svc.subscriber.projectId == null) {
        svc.subscriber.status = 'invalid';
    }
    else {
        svc.subscriberParams = '?npeid=' + svc.subscriber.npeId + '&pid=' + svc.subscriber.projectId;
    }

    // get user
    svc.getuser = function () {

        // get subscriber from db
        var deferred = $q.defer();

        if(svc.subscriber.status !== 'unknown') {
            deferred.resolve(svc.subscriber);
            //console.log(svc.subscriber, 'subscriber retrieved (cache)');

        } else {
            $http.get('/api/subscriber' + svc.subscriberParams)
                .then(function(response) {
                    svc.subscriber = response.data;
                    console.log(svc.subscriber, 'response.data');
                    console.log(svc.subscriber, 'subscriber retrieved');
                    deferred.resolve(svc.subscriber);

                }, function(err) {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    };

    // unsubscribe
    svc.unsubscribe = function () {

        return $http.get('/api/unsubscribe' + svc.subscriberParams)
             .then(function (response) {
                 svc.subscriber = response.data;
                 console.log(svc.subscriber, 'response.data');
                 console.log(svc.subscriber, 'subscriber retrieved');
                 return svc.subscriber;
             });
    };


    // resubscribe
    svc.resubscribe = function () {
        return $http.get('/api/resubscribe' + svc.subscriberParams)
             .then(function (response) {
                 svc.subscriber = response.data;
                 console.log(svc.subscriber, 'response.data');
                 console.log(svc.subscriber, 'subscriber retrieved');
                 return svc.subscriber;
             });
    };

    return svc;
};

